import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "../Response/responseSlice";
import { AuthUser } from "../../Services/login_service";
import { storageService } from "../../Services/storage_service";
import { setLoading, setDismissibleModal, setPasswordInput, setShowLogin, setAlert } from "../uiSlice";

const initialState = {
    authUser: {
        idUsuario: 0,
        usuario: '',
        idRol: 0,
        rol: '',
        minCapacita: 0,
        token: '',
        ruta: '',
        onboardingFinalizado: false,
        nombre: '',
        segmento: null,
        codSegmento: null,
    },
}

export const authSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        setAuthUser: (state, action) => {
            state.authUser = action.payload;
        },
        resetAuthUser: () => initialState,
    }
});


export const userLogin = createAsyncThunk(
    'login/auth',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        dispatch(setDismissibleModal('false'));
        dispatch(setPasswordInput(true));

        const resp = await AuthUser(data);
        dispatch(setResponse({
            mensajeRespuesta: resp.message,
            codigoRespuesta: resp.result,
        }));

        if (resp.result === 1) {
            dispatch(setAuthUser(resp.data[0]));
            storageService.setItem('user', resp.data[0]);
            dispatch(setDismissibleModal('true'));
            dispatch(setShowLogin(false));
            dispatch(setLoading(false));
        } else {
            dispatch(setAlert(true));
            dispatch(setDismissibleModal(true));
            dispatch(setLoading(false));
        }
        setTimeout(() => {
            dispatch(setAlert(false));
        }, 4000);
    }
);

export const { setAuthUser, resetAuthUser } = authSlice.actions;
export default authSlice.reducer;